export function changeAppLinksFunc(){

    let appLinks = [].slice.call(document.getElementsByClassName("replace-app-link"));

    appLinks.forEach.call(appLinks, function (el) {
        el.href = el.dataset.href;
        el.classList.remove('replace-app-link');
    });
    
}